// Shared constants for the Cuentas y Usuarios module.

export const ACCOUNT_TYPES = [
    { value: 'cus', label: 'Cliente' },
    { value: 'hub', label: 'Autopublicado' },
];

// Display labels for account types by code (used in tables/lists).
export const TYPE_LABELS = {
    cus: 'Cliente',
    hub: 'Autopublicado',
    can: 'CANIEM',
    aut: 'Autor',
    und: 'Indefinido',
    app: 'App',
    gan: 'Gandhi',
};

// account_tier is extensible; currently only CANIEM exists.
export const ACCOUNT_TIERS = [
    { value: 'can', label: 'CANIEM' },
];

// Display labels for account tiers by code.
export const TIER_LABELS = {
    can: 'CANIEM',
};

export const SERVICES = [
    { key: 'dist', label: 'Distribución' },
    { key: 'conv', label: 'Conversión' },
    { key: 'ingram', label: 'Ingram' },
    { key: 'biblio', label: 'Biblio' },
];

export const SERVICE_FILTERS = [
    { value: 'dist', label: 'Distribución' },
    { value: 'conv', label: 'Conversión' },
    { value: 'ingram', label: 'Ingram' },
    { value: 'biblio', label: 'Biblio' },
];

export const DIST_PERCENTS = [15, 18, 23];

// Percent publishers (channel_ink_percentage) options.
export const BUSINESS_MODELS = [
    { value: 'sale', label: 'Venta' },
    { value: 'subscription', label: 'Suscripción' },
    { value: 'loan', label: 'Préstamo' },
];

export const CONTENT_TYPES = [
    { value: 'ebook', label: 'Ebook' },
    { value: 'audiobook', label: 'Audiobook' },
];

export const APPLY_OPTIONS = [
    { value: 'pvp', label: 'Precio de venta' },
    { value: 'rev', label: 'Paga la tienda' },
];

export const SERVICE_LABELS = {
    dist: 'Distribución',
    conv: 'Conversión',
    ingram: 'Ingram',
    biblio: 'Biblio',
    audiobooks: 'Audiobooks',
};